/* eslint-disable prettier/prettier */
import React from 'react';
import Context from './Utilities';
import './App.css';
// import 'semantic-ui-css/semantic.min.css';

import {
    Header,
    Intro,
    Question1,
    Question2,
    Question3,
    Compare,
    Similar,
    Quotes,
} from './Components';

const { Component } = window.wp.element;

class App extends Component {
    constructor() {
        super();

        this.state = {
            data: [],
            approval: 'Disapprove',
            share: 'Share',
            why: 'inform',
            type: 'DisapproveShare',
            toggleShare: this.toggleShare,
            toggleApproval: this.toggleApproval,
            toggleWhy: this.toggleWhy,
        };
    }

    GetData = () => {
        fetch(`${window.siteURL}/wp-json/prc-api/v2/interactive?slug=dinner-party`)
            .then(res => res.json())
            .then(
                result => {
                    this.ConstructData(result);
                },
                error => {
                    this.setState({
                        isLoaded: false,
                        error,
                    });
                },
            );
    };

    ConstructData = result => {
        const data = [];
        let index = -1;
        for (const quote in result) {
            index++;
            data.push({
                age: result[quote].age,
                gender: result[quote].gender,
                quote: result[quote].quote,
                type: result[quote].type,
            });
        }
        this.setState({
            data,
            isLoaded: true,
        });
    };

    scrollToRef = ref =>
        window.scrollTo({ behavior: 'smooth', top: ref.offsetTop });

    toggleShare = e => {
        const share = e.target.id;
        this.setState({
            share,
            why: this.state.why,
            approval: this.state.approval,
        });
        // Switch active button
        [...e.target.parentElement.children].forEach(sib =>
            sib.classList.remove('active'));
        e.target.classList.add('active');
        // Make next question appear and the scroll to it
        const question2 = document.getElementById('question2');
        question2.classList.add('active');
        // detect support for the behavior property in ScrollOptions
        const supportsNativeSmoothScroll =
            'scrollBehavior' in document.documentElement.style;

        if (supportsNativeSmoothScroll) {
            setTimeout(() => {
                // Pause before dropping down
                this.scrollToRef(question2);
            }, 300);
        } else {
            return;
        }

        if ('none' !== this.state.type) {
            const type = this.state.approval.concat(share);
            this.changeImage(type);
            this.setState({
                type,
            });
        }

        // If the user changes their answer to question 1, it will de-select the question 2 button so it can switch out answers. It will also hide q3 again until q2 is answered.
        const question3 = document.querySelector('#question3.active');
        if (null !== question3) {
            question3.classList.remove('active');
        }
        const activeButton = document.querySelector('#question2 .ui.button.active');
        if (null !== activeButton) {
            activeButton.classList.remove('active');
        }
    };

    toggleWhy = e => {
        const why = e.target.id;
        this.setState({
            why,
            share: this.state.share,
            approval: this.state.approval,
            type: this.state.type,
        });
        // Switch active button
        [...e.target.parentElement.children].forEach(sib =>
            sib.classList.remove('active'));
        e.target.classList.add('active');
        // Make next question appear and the scroll to it
        const question3 = document.getElementById('question3');
        question3.classList.add('active');
        // detect support for the behavior property in ScrollOptions
        const supportsNativeSmoothScroll =
            'scrollBehavior' in document.documentElement.style;

        if (supportsNativeSmoothScroll) {
            setTimeout(() => {
                // Pause before dropping down
                this.scrollToRef(question3);
            }, 300);
        } else {
        }
    };

    toggleApproval = e => {
        const approval = e.currentTarget.id;
        const { share } = this.state;
        const type = approval.concat(share);
        this.setState({
            approval,
            type,
            why: this.state.why,
            share: this.state.share,
        });
        // Switch active button
        [...e.currentTarget.parentElement.children].forEach(sib =>
            sib.classList.remove('active'));
        e.currentTarget.classList.add('active');

        // Make the rest of the interactive appear
        const compare = document.getElementById('compare');
        compare.classList.add('active');
        const similar = document.getElementById('similar');
        similar.classList.add('active');
        const quotes = document.getElementById('quotes');
        quotes.classList.add('active');

        this.changeImage(type);
    };

    changeImage = type => {
        // Switch active image for selected type
        const img = document.getElementById('q3img');
        img.src = `https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Path_${type}/Path_${type}_2.png`;
    };

    render() {
        const { error, isLoaded } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        }
        if (!isLoaded) {
            this.GetData();
            return <div>Loading...</div>;
        }
        return (
            <div className="App">
                <Context.Provider value={this.state}>
                    <Header />
                    <Intro />
                    <Question1 />
                    <Question2 />
                    <Question3 />
                    <Compare />
                    <Similar />
                    <Quotes />
                </Context.Provider>
            </div>
        );
    }
}
export default App;
